import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllOAuthProvidersKey, OAUTH_PROVIDERS_ENDPOINT } from "./useGetAllOAuthProviders";

export const useDeleteOAuthProvider = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            return loggedInApiCall.delete(`${OAUTH_PROVIDERS_ENDPOINT}/${id}`);
        },
        onSuccess: () => queryClient.invalidateQueries([getAllOAuthProvidersKey]),
    });

    return query;
};
